import { render, staticRenderFns } from "./product_2_yhw.vue?vue&type=template&id=df1b13fe&scoped=true"
import script from "./product_2_yhw.vue?vue&type=script&lang=js"
export * from "./product_2_yhw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1b13fe",
  null
  
)

export default component.exports